import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CacheControlService } from './shared/services/cache-control.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  environment = environment;
  title = 'TeamApp';

  constructor(
    private cacheControlService: CacheControlService
  ) {}

  ngOnInit() {
    // Removed auction service redirect logic - nginx handles these routes directly
  }
}
